export default "__VITE_ASSET__BznUZi2N__"